import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom }: Theme) => ({
  root: {
    width: 37,
    height: 37,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logo: {
    maxWidth: 37,
    maxHeight: 37,
    transition: 'opacity 0.1s',
  },
}));
